<script>
    import IconSearch from '@/components/icon/IconSearch.vue';

    export default {
        components: {
            ButtonIcon: IconSearch,
        },
        computed: {
            getShowGlobalSearch() { return this.$store.getters.IS_SHOW_GLOBAL_SEARCH },
        },
        methods: {
            toggleShowGlobalSearch() {
                this.$store.commit('IS_SHOW_GLOBAL_SEARCH', !this.getShowGlobalSearch);
            }
        }
    }
</script>


<template>
    <button 
        class="left_button_main_container"
        @click="toggleShowGlobalSearch"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Global Search</label>
        </div>
    </button>
</template>